import React from 'react';

/*
import {
  hf,
  ht,
  cr,
  a,
  ls,
  f,
  gs,
  useMsgz,
  BoxC,
  BtnC,
  BtnCttC,
  IptC,
  LblC,
  TblC,
  TextC,
  GridC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as IptC from "./_ccbIptC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as BtnC from "./_cccBtnC";
import * as LblC from "./_cccLblC";
import * as BtnCttC from "./_ccmBtnCttC";
import * as TblC from "./_ccmTblC";
import * as cmFTH from "./_cmFTH"; // 廃止予定
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import { useMsgz } from "./_csMdlMsg";
import * as ht from './_ht';
import * as hf from './_hf';

import * as ihd from 'src/ihd';
import * as ica from 'src/ica';

import * as icvi10 from './icvI10___Mz';
import * as icvi15 from './icvI15___Mz';
import * as icvi17 from './icvI17___Mz';

let $i10rs = [] as ht.ls;
let $i17rs = [] as ht.ls;

let $i15z = icvi15.ilzI15z();

export const B = (pz: ht.btnCttCz) => {
  const _sMsgz = useMsgz();
  return (
    cr.c(BtnCttC.N, {
      key: -10,
      ... pz,
      cz: {
        ... pz.cz,
        ugdAsync: async () => {
          const _i15rz = $i15z.i15rz;
          const _b = await hf.ectSrlAsync([
            async () => { // 必須項目の確認
              let _b = true;
              if (
                !hf.f(_i15rz._icn) || // 部屋ID
                !hf.f(_i15rz._pfx) // 部屋名
              ) _b = false;
              if (!_b) {
                _sMsgz.show({
                  textCz: {
                    textz: {
                      pfx: '必須項目が入力されていないため、指定された操作を行うことができません',
                    }
                  }
                })
              }
              return _b;
            },
          ])
          if (_b) {
            const _i15z = await icvi15.saveI15rDzAsync({
              ... pz,
              i15z: $i15z,
            });
            return {
              i15r_fst :_i15z.i15rz._fst,
            };
          }
        }
      }
    })
  );
};

//export const D = (pz: ht.viewDtlCz & { vsn: ht.n }) => {
export const D = (pz: ht.viewDtlCz) => {

  const _gUserz = gs.useUserz();
//hf.l(`icvI15___Ci 82: ${hf.s(_gUserz.crt.i19rz.i19ra4100i)}`);
  const _udtThis = ls.udtThis();

  React.useEffect(() => {
    cmFTH.loadAllAsync({
      phs: pz.sPz.crt.phs,
      frcUdt: _udtThis,
      bfrAsync: () => [
        icvi10.loadI10rLsAsync({
          _31r_fst: 0 // クライアント共通
        })
        .then((_ls: ht.ls) => {
          $i10rs = _ls;
        }),
        icvi17.loadI17rLsAsync({
          _31r_fst: 0 // クライアント共通
        })
        .then((_ls: ht.ls) => {
          $i17rs = _ls;
        }),
      ],
      crtAsync: () => [
        icvi15.crtI15zAsync()
        .then((_dz: ht.dz) => {
          $i15z = _dz;
        })
      ],
      udtAsync: () => [
        icvi15.loadI15rDzAsync({
          i15r_fst: pz.sPz.crt.i15r_fst,
          vsn: pz.sPz.crt.vsn,
        })
        .then((_dz: ht.dz) => {
          $i15z = _dz;
        })
      ],
    })
  }, [
    pz.sPz.crt.phs,
    pz.sPz.crt.i15r_fst,
    pz.sPz.crt.vsn,
  ])

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.viewDtlAbtz[_abtType] ? ica.viewDtlAbtz[_abtType]() : {};

  const _hdrs1 = [] as ht.ls;
  _hdrs1.push({
    cellCs: [
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            ... _abtz.cldz.hdrCz.textCz,
            textz: {
              pfx: 'この団体において予約できない部屋'
            }
          })
        ]
      },
    ],
  });

  const _bdys1 = [] as ht.ls;
  $i15z?.i151s.filter( ( i151z:ht.dz ) => i151z._dlt != 1 )
  .map( ( i151z:ht.dz, _nIdx: ht.n ) => {
    _bdys1.push({
      cellCs: [
        {
          oClds: [
            cr.c(IptC.S, {
              key: -10,
              cz: {
                bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                iptType: 'pcr',
                vle: i151z.i151i10r1f,
                ls: $i10rs,
                onChg: ( _dz: ht.dz ) => {
                  i151z.i151i10r1f = _dz.key;
                }
              }
            })
          ]
        },
        {
          boxStlz: a('dw/10 f/n'),
          oClds: [
            hf.i(pz.sPz.crt.phs, ['crt', 'udt']) ?
            cr.c(BtnC.N, {
              key: -10,
              ... _abtz.cldz.bdyCz.btnDltCz,
              bfrIconCz: {},
              lblCz: {},
              pslPtyz: {
                onPress: () => {
                  i151z._dlt = 1;
                  _udtThis();
                },
              }
            })
            : null,
          ]
        },
      ],
    });
  });  
  if ( hf.i(pz.sPz.crt.phs, ['crt', 'udt']) ) {
    _bdys1.push({
      cellCs: [
        {
          oClds: [
            cr.c(BtnC.N, {
              key: -10,
              ... _abtz.cldz.bdyCz.btnAddCz,
              bfrIconCz: {},
              lblCz: {},
              pslPtyz: {
                onPress: () => {
                  $i15z?.i151s.push({
                    i151i10r1f: -1,
                  });
                  _udtThis();
                },
              }
            })
          ]
        },
      ],
    });
  }

  const _hdrs2 = [] as ht.ls;
  _hdrs2.push({
    cellCs: [
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            ... _abtz.cldz.hdrCz.textCz,
            textz: {
//              pfx: '予約不可の備品・駐車場'
              pfx: 'この団体において予約できない備品・駐車場'
            }
          })
        ]
      },
/*
      {
        boxStlz: a('dw/10 f/n'),
        oClds: [
        ]
      },
*/
    ],
  });

  const _bdys2 = [] as ht.ls;
  $i15z?.i152s.filter( ( i152z:ht.dz ) => i152z._dlt != 1 )
  .map( ( i152z:ht.dz, _nIdx: ht.n ) => {
    _bdys2.push({
      cellCs: [
        {
          oClds: [
            cr.c(IptC.S, {
              key: -10,
              cz: {
                bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                iptType: 'pcr',
                vle: i152z.i152i17r1f,
                ls: $i17rs,
                onChg: ( _dz: ht.dz ) => {
                  i152z.i152i17r1f = _dz.key;
                }
              }
            })
          ]
        },
        {
          boxStlz: a('dw/10 f/n'),
          oClds: [
            hf.i(pz.sPz.crt.phs, ['crt', 'udt']) ?
            cr.c(BtnC.N, {
              key: -10,
              ... _abtz.cldz.bdyCz.btnDltCz,
              bfrIconCz: {},
              lblCz: {},
              pslPtyz: {
                onPress: () => {
                  i152z._dlt = 1;
                  _udtThis();
                },
              }
            })
            : null,
          ]
        },
      ],
    });
  });  
  if ( hf.i(pz.sPz.crt.phs, ['crt', 'udt']) ) {
    _bdys2.push({
      cellCs: [
        {
          oClds: [
            cr.c(BtnC.N, {
              key: -10,
              ... _abtz.cldz.bdyCz.btnAddCz,
              bfrIconCz: {},
              lblCz: {},
              pslPtyz: {
                onPress: () => {
                  $i15z?.i152s.push({
                    i152i17r1f: -1,
                  });
                  _udtThis();
                },
              }
            })
          ]
        },
      ],
    });
  }

//hf.l(`icvI15___Ci 308: here`)
//hf.l(`icvI15___Ci 307: ${hf.s(_gUserz.crt.i19rz.i19ra4100i == 3)}`)
  return (
    cr.c(BoxC.N, {
      key: -10,
      boxStlz: a('dw/f fd/csc'),
      oClds: [

        hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
        cr.c(TextC.N, {
          key: -10,
          abtType: 'rmkCmnz',
          boxStlz: a(`dw/f fd/rsc mb/1`),
          textz: {
            pfx: '※：必須'
          }
        })
        : null,

        cr.c(GridC.N, {
          key: -20,
          abtType: 'nolineCmnz',
          boxStlz: a('dwx/60 mb/1 mh/a'),
          lineCs: [
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/18`),
                        textz: {
                          pfx: '団体種別ID：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            vle: $i15z?.i15rz._icn,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i15z?.i15rz._icn,
                              onChg: ( _s: ht.s ) => {
                                $i15z.i15rz._icn = _s;
                              },
                            }
                          })
                        ],
                      },
                      omtCz: 
                        hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                        {
                          abtType: 'omtRqrCmnz',
                        }
                        : undefined,
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/18`),
                        textz: {
                          pfx: '団体種別名：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i15z?.i15rz._pfx ?? '',
                              onChg: ( _s: ht.s ) => {
                                $i15z.i15rz._pfx = _s;
                              },
                            }
                          })
                        ],
                      },
                      omtCz: 
                        hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                        {
                          abtType: 'omtRqrCmnz',
                        }
                        : undefined,
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/18`),
                        textz: {
                          pfx: '利用料の請求：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'pcr',
                              ls: ihd.f('i15ra1100i').ls,
                              vle: $i15z?.i15rz.i15ra1100i,
                              onChg: ( _dz: ht.dz ) => {
                                $i15z.i15rz.i15ra1100i = _dz.key;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/18`),
                        textz: {
                          pfx: 'エントリー申込：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'pcr',
                              ls: ihd.f('i15ra2100i').ls,
                              vle: $i15z?.i15rz.i15ra2100i,
                              onChg: ( _dz: ht.dz ) => {
                                $i15z.i15rz.i15ra2100i = _dz.key;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/18`),
                        textz: {
                          pfx: '予約可能期間：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'pcr',
                              ls: ihd.f('i15ra3100i').ls,
                              vle: $i15z?.i15rz.i15ra3100i,
                              onChg: ( _dz: ht.dz ) => {
                                $i15z.i15rz.i15ra3100i = _dz.key;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/18`),
                        textz: {
                          pfx: '団体名併記文言：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i15z?.i15rz.i15ra4100s ?? '',
                              onChg: ( _s: ht.s ) => {
                                $i15z.i15rz.i15ra4100s = _s;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/18`),
                        textz: {
                          pfx: '時間帯種別：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'pcr',
                              ls: ihd.f('i15ra6100i').ls,
                              vle: $i15z?.i15rz.i15ra6100i,
                              onChg: ( _dz: ht.dz ) => {
                                $i15z.i15rz.i15ra6100i = _dz.key;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
            _gUserz.crt.i19rz.i19ra2410i == 1?
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/18`),
                        textz: {
                          pfx: '外部連携区分：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'pcr',
                              ls: ihd.f('i15ra7100i').ls,
                              vle: $i15z?.i15rz.i15ra7100i,
                              onChg: ( _dz: ht.dz ) => {
                                $i15z.i15rz.i15ra7100i = _dz.key;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            }
            : undefined,
          ]
        }),

        cr.c(GridC.N, {
          key: -30,
          abtType: 'nolineCmnz',
          boxStlz: a('dwx/100 mb/2 mh/a'),
          lineCs: [
            _gUserz.crt.i19rz.i19ra4100i == 3 ?
            {
              cellCs: [
                {
                  boxStlz: a('dw/14 f/n fd/rsc'),
                  oClds: [
                    cr.c(TextC.N, {
                      key: -10,
                      abtType: 'lblStfz',
                      textz: {
                        pfx: '（5ヶ月前）',
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/16`),
                        textz: {
                          pfx: '予約基準日：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i15z?.i15rz.i15ra8510i ?? 1,
                              onChg: ( _s: ht.s ) => {
                                $i15z.i15rz.i15ra8510i = _s;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/16`),
                        textz: {
                          pfx: '予約基準時刻：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i15z?.i15rz.i15ra8512s,
                              onChg: ( _s: ht.s ) => {
                                $i15z.i15rz.i15ra8512s = _s;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/16`),
                        textz: {
                          pfx: '予約可能件数：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i15z?.i15rz.i15ra8520i ?? 2,
                              onChg: ( _s: ht.s ) => {
                                $i15z.i15rz.i15ra8520i = _s;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            }
            : undefined,
            _gUserz.crt.i19rz.i19ra4100i == 3 ?
            {
              cellCs: [
                {
                  boxStlz: a('dw/14 f/n fd/rsc'),
                  oClds: [
                    cr.c(TextC.N, {
                      key: -10,
                      abtType: 'lblStfz',
                      textz: {
                        pfx: '（4ヶ月前）',
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/16`),
                        textz: {
                          pfx: '予約基準日：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i15z?.i15rz.i15ra8410i ?? 1,
                              onChg: ( _s: ht.s ) => {
                                $i15z.i15rz.i15ra8410i = _s;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/16`),
                        textz: {
                          pfx: '予約基準時刻：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i15z?.i15rz.i15ra8412s,
                              onChg: ( _s: ht.s ) => {
                                $i15z.i15rz.i15ra8412s = _s;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/16`),
                        textz: {
                          pfx: '予約可能件数：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i15z?.i15rz.i15ra8420i ?? 2,
                              onChg: ( _s: ht.s ) => {
                                $i15z.i15rz.i15ra8420i = _s;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            }
            : undefined,
            _gUserz.crt.i19rz.i19ra4100i == 3 ?
            {
              cellCs: [
                {
                  boxStlz: a('dw/14 f/n fd/rsc'),
                  oClds: [
                    cr.c(TextC.N, {
                      key: -10,
                      abtType: 'lblStfz',
                      textz: {
                        pfx: '（3ヶ月前）',
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/16`),
                        textz: {
                          pfx: '予約基準日：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i15z?.i15rz.i15ra8310i ?? 1,
                              onChg: ( _s: ht.s ) => {
                                $i15z.i15rz.i15ra8310i = _s;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/16`),
                        textz: {
                          pfx: '予約基準時刻：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i15z?.i15rz.i15ra8312s,
                              onChg: ( _s: ht.s ) => {
                                $i15z.i15rz.i15ra8312s = _s;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/16`),
                        textz: {
                          pfx: '予約可能件数：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i15z?.i15rz.i15ra8320i ?? 2,
                              onChg: ( _s: ht.s ) => {
                                $i15z.i15rz.i15ra8320i = _s;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            }
            : undefined,
            {
              cellCs: [
                {
                  boxStlz: a('dw/14 f/n fd/rsc'),
                  oClds: [
                    cr.c(TextC.N, {
                      key: -10,
                      abtType: 'lblStfz',
                      textz: {
                        pfx: '（2ヶ月前）',
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/16`),
                        textz: {
                          pfx: '予約基準日：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i15z?.i15rz.i15ra8210i ?? 1,
                              onChg: ( _s: ht.s ) => {
                                $i15z.i15rz.i15ra8210i = _s;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/16`),
                        textz: {
                          pfx: '予約基準時刻：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i15z?.i15rz.i15ra8212s,
                              onChg: ( _s: ht.s ) => {
                                $i15z.i15rz.i15ra8212s = _s;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/16`),
                        textz: {
                          pfx: '予約可能件数：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
/*
                              vle: $i15z?.i15rz.i15ra5120i ?? 2,
                              onChg: ( _s: ht.s ) => {
                                $i15z.i15rz.i15ra5120i = _s;
                              },
*/
                              vle: $i15z?.i15rz.i15ra8220i ?? 2,
                              onChg: ( _s: ht.s ) => {
                                $i15z.i15rz.i15ra8220i = _s;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
            {
              cellCs: [
                {
                  boxStlz: a('dw/14 f/n fd/rsc'),
                  oClds: [
                    cr.c(TextC.N, {
                      key: -10,
                      abtType: 'lblStfz',
                      textz: {
                        pfx: '（1ヶ月前）',
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/16`),
                        textz: {
                          pfx: '予約基準日：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i15z?.i15rz.i15ra8110i ?? 1,
                              onChg: ( _s: ht.s ) => {
                                $i15z.i15rz.i15ra8110i = _s;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/16`),
                        textz: {
                          pfx: '予約基準時刻：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i15z?.i15rz.i15ra8112s,
                              onChg: ( _s: ht.s ) => {
                                $i15z.i15rz.i15ra8112s = _s;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/16`),
                        textz: {
                          pfx: '予約可能件数：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
/*
                              vle: $i15z?.i15rz.i15ra5220i ?? 10,
                              onChg: ( _s: ht.s ) => {
                                $i15z.i15rz.i15ra5220i = _s;
                              },
*/
                              vle: $i15z?.i15rz.i15ra8120i ?? 10,
                              onChg: ( _s: ht.s ) => {
                                $i15z.i15rz.i15ra8120i = _s;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
            {
              cellCs: [
                {
                  boxStlz: a('dw/14 f/n fd/rsc'),
                  oClds: [
                    cr.c(TextC.N, {
                      key: -10,
                      abtType: 'lblStfz',
                      textz: {
                        pfx: '（当月）',
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/16`),
                        textz: {
                          pfx: '予約基準日：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i15z?.i15rz.i15ra8010i ?? 1,
                              onChg: ( _s: ht.s ) => {
                                $i15z.i15rz.i15ra8010i = _s;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/16`),
                        textz: {
                          pfx: '予約基準時刻：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i15z?.i15rz.i15ra8012s,
                              onChg: ( _s: ht.s ) => {
                                $i15z.i15rz.i15ra8012s = _s;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/16`),
                        textz: {
                          pfx: '予約可能件数：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
/*
                              vle: $i15z?.i15rz.i15ra5320i ?? 10,
                              onChg: ( _s: ht.s ) => {
                                $i15z.i15rz.i15ra5320i = _s;
                              },
*/
                              vle: $i15z?.i15rz.i15ra8020i ?? 10,
                              onChg: ( _s: ht.s ) => {
                                $i15z.i15rz.i15ra8020i = _s;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
          ]
        }),

        cr.c(TblC.N, {
          key: -40,
          ... _abtz.cldz.tblCz,
          srlCz: {
            srlStlz: {
              otrz: a('dwx/50 f/n mb/2'),
            }
          },
          hdrCz: {
            lineCs: _hdrs1
          },
          bdyCz: {
            lineCs: _bdys1
          }
        }),

        _gUserz.crt.i19rz.i19ra2210i == 1 ?
        cr.c(TblC.N, {
          key: -50,
          ... _abtz.cldz.tblCz,
          srlCz: {
            srlStlz: {
              otrz: a('dwx/50 f/n'),
            }
          },
          hdrCz: {
            lineCs: _hdrs2
          },
          bdyCz: {
            lineCs: _bdys2
          }
        })
        : undefined

      ]
    })
  );
};

